__turbopack_context__.v({
  "showMoreButton": "style-module-scss-module__65XjXG__showMoreButton",
  "title": "style-module-scss-module__65XjXG__title",
  "wrapper": "style-module-scss-module__65XjXG__wrapper",
});
